import React, { SVGAttributes } from 'react';
import slColors from 'sl-colors';

interface Props extends SVGAttributes<SVGSVGElement> {
  color?: string;
}

export default function OcHighFive({ color = slColors.primary[800], ...rest }: Props) {
  return (
    <svg
      width="233"
      height="202"
      viewBox="0 0 233 202"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M1.11654 195.653C-1.0428 193.738 8.5515 193.88 13.2869 193.791C13.9688 194.748 14.4707 194.766 15.7019 194.988C16.2702 196.45 3.27587 197.567 1.11654 195.653Z"
        fill={color}
      />
      <path
        d="M74.9461 50.916C74.507 52.5052 74.1797 57.669 75.9041 61.9063"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M73.5508 62.9454C77.6431 61.4789 85.4361 59.6843 85.4361 64.7571V65.6375C85.4361 66.2319 86.115 66.5686 86.5846 66.2046C93.1543 61.1145 106.522 50.9166 111.232 43.1973"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M91.6864 23.7051C95.7066 26.8701 101.946 33.7019 95.8816 36.4812C95.5259 36.6439 95.3297 37.038 95.431 37.4138C96.6243 41.8324 96.4356 50.9565 87.179 57.1353C87.0412 57.2271 86.9351 57.3637 86.885 57.5207L85.0645 63.2176"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M87.7059 46.9922C87.5631 47.6202 87.9341 48.9181 90.5581 49.0856"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M94.7449 30.5031C94.7449 31.8792 94.3288 33.0893 93.6997 33.9346C93.0706 34.7795 92.274 35.2132 91.474 35.2132C90.6741 35.2132 89.8775 34.7795 89.2484 33.9346C88.6193 33.0893 88.2031 31.8792 88.2031 30.5031C88.2031 29.127 88.6193 27.9169 89.2484 27.0716C89.8775 26.2267 90.6741 25.793 91.474 25.793C92.274 25.793 93.0706 26.2267 93.6997 27.0716C94.3288 27.9169 94.7449 29.127 94.7449 30.5031Z"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M79.5684 34.6948L87.6802 31.8164"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M85.8496 29.2005C86.0562 28.3284 86.8165 26.322 88.2047 25.2754"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M91.867 31.2946C92.4451 31.2946 92.9137 30.9432 92.9137 30.5096C92.9137 30.0761 92.4451 29.7246 91.867 29.7246C91.2889 29.7246 90.8203 30.0761 90.8203 30.5096C90.8203 30.9432 91.2889 31.2946 91.867 31.2946Z"
        fill={color}
      />
      <path
        d="M88.3069 117.12C87.8251 111.976 87.4395 100.625 89.7528 96.3717C92.0662 92.118 94.2888 86.0338 95.8521 83.5723C101.109 80.5375 113.638 68.8941 121.697 46.5996"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M73.5494 62.6953L43.457 98.0211"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M43.457 98.1299C45.6881 97.8285 51.4877 97.9748 56.8416 100.972C63.534 104.719 70.6196 111.309 88.2031 117.124"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M88.204 117.121L82.1855 121.308"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M43.4605 98.0215C43.0528 99.2851 42.6481 102.232 46.0737 105.872"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M65.4376 72.375C60.568 76.4313 48.22 84.9888 37.7849 86.7685C35.3502 87.7716 31.1588 90.589 33.8719 93.834C36.585 97.0793 38.3938 101.031 38.9591 102.601C39.3939 104.04 40.4762 106.047 43.085 101.441"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M34.8216 95.1406C32.8 96.3328 28.0857 98.6107 25.4016 98.1867C22.7176 97.763 20.9282 98.8932 20.369 99.5113C20.0679 99.9969 19.8787 100.995 21.5304 101.101C23.1821 101.207 25.1436 101.145 25.9178 101.101"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M28.0196 99.3281C27.1142 100.343 24.0357 102.648 18.9651 103.755C17.9734 103.94 16.6368 105 18.4477 106.246C19.9999 107.214 24.2943 106.329 26.4674 105"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M26.4428 104.822C24.7798 105.659 21.7862 107.888 23.1167 110.109C23.5431 110.549 25.3426 110.584 29.1293 107.201L31.9437 104.822"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M32.0855 104.872L29.2119 107.272C28.3847 109.451 27.1221 114.741 30.5181 111.807C32.9998 109.273 32.4773 107.113 33.5222 106.472C34.5671 105.832 36.9182 103.361 37.9631 102.205"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M32.2094 100.633C31.8613 101.71 31.5828 104.213 33.2537 105.605"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M63.8672 188.817C65.5132 188.381 68.8312 186.174 68.935 180.836C69.0392 175.498 71.2309 166.313 72.3136 162.388L82.9693 115.287"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M86.8944 39.4022C87.1835 39.4022 87.4178 39.2265 87.4178 39.0097C87.4178 38.7929 87.1835 38.6172 86.8944 38.6172C86.6054 38.6172 86.3711 38.7929 86.3711 39.0097C86.3711 39.2265 86.6054 39.4022 86.8944 39.4022Z"
        fill={color}
      />
      <path
        d="M88.5956 40.9765C88.8124 40.9765 88.9881 40.8593 88.9881 40.7148C88.9881 40.5703 88.8124 40.4531 88.5956 40.4531C88.3789 40.4531 88.2031 40.5703 88.2031 40.7148C88.2031 40.8593 88.3789 40.9765 88.5956 40.9765Z"
        fill={color}
      />
      <path
        d="M84.8027 42.0213C84.9472 42.0213 85.0644 41.787 85.0644 41.498C85.0644 41.2089 84.9472 40.9746 84.8027 40.9746C84.6582 40.9746 84.541 41.2089 84.541 41.498C84.541 41.787 84.6582 42.0213 84.8027 42.0213Z"
        fill={color}
      />
      <path
        d="M46.1378 35.6569C52.4971 23.8368 61.9926 22.3507 65.9457 23.085C74.1554 10.513 85.4929 6.36567 92.3995 10.1243C97.925 13.1311 93.3988 20.7089 90.4449 24.122L87.5781 19.9746C85.5972 23.8109 79.933 22.3938 77.1527 21.5298C79.5417 26.5412 83.3556 39.4936 75.3282 51.21C67.3011 62.9265 57.2146 63.1336 52.132 59.764C47.4408 56.4376 39.7785 47.4773 46.1378 35.6569Z"
        fill={color}
      />
      <path
        d="M42.9336 190.391C43.801 191.748 46.69 194.311 51.3071 193.7"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M50.2059 98.8047C48.5687 103.488 40.8978 113.115 34.046 125.214C29.478 132.803 18.584 149.75 11.5511 156.827C10.6031 158.172 9.7153 161.225 13.7489 162.682C16.8516 163.983 18.2478 167.001 18.6615 170.227C19.1787 174.26 25.772 177.252 30.1675 174.26C33.671 171.875 43.745 154.696 51.3557 144.989C53.2935 142.517 55.0715 140.53 56.5408 139.395"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M51.5437 145.121L42.9336 190.39C47.31 189.223 59.3318 187.018 66.7458 187.018"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M8.69063 186.648C1.55829 172.822 8.16991 163.622 11.7457 161.344C17.2889 163.087 17.4387 168.899 18.3376 171.66L16.263 177.341C14.8747 179.784 15.6845 184.564 16.263 186.648C18.6608 196.304 15.0417 197.233 13.2656 194.647L8.69063 186.648Z"
        fill={color}
      />
      <path
        d="M46.7179 199.324C44.3154 197.422 49.0671 196.684 53.8887 196.406C55.5684 197.908 66.7253 198.421 67.2697 198.768C62.1369 200.437 48.8233 200.992 46.7179 199.324Z"
        fill={color}
      />
      <path
        d="M70.8502 198.51C52.6346 201.007 48.8541 193.803 49.2408 189.591C52.3736 188.283 60.988 187.807 65.049 187.51C63.8886 190.245 65.3389 189.888 66.3542 190.631C67.6597 191.523 71.2853 192.614 73.3158 192.713C82.4526 193.159 75.2979 197.866 70.8502 198.51Z"
        fill={color}
      />
      <path
        d="M113.76 20.165C114.594 19.6852 116.315 19.5108 116.525 22.6509"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M112.075 28.5384C112.162 27.3174 112.075 24.5348 111.028 23.1741C109.72 21.4733 109.458 18.2024 112.075 18.464C112.905 18.5471 113.434 19.2372 113.758 20.1649C114.252 21.5751 114.273 23.5341 114.168 24.7442"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M110.43 31.9367C110.324 30.7592 109.877 28.0378 108.935 26.5724C107.757 24.7408 107.626 20.0307 110.112 20.554"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M112.076 40.8354C111.421 40.8354 110.035 40.2074 109.721 37.6953C109.406 35.1833 108.281 33.596 107.758 33.1161C107.453 32.3747 107.13 30.8395 108.281 30.6302C108.959 30.5069 109.761 31.164 110.431 31.9385L111.552 33.5086"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M118.095 29.1923C118.4 28.6255 118.697 27.1774 117.441 25.9215C115.871 24.3514 116.263 22.9122 117.179 22.5197C118.095 22.1272 119.403 22.3889 120.712 26.314C122.02 29.7157 123.956 38.3509 121.758 45.6777"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M124.07 8.71669L126.123 4.98438"
        stroke={color}
        strokeWidth="1.57004"
        strokeLinecap="round"
      />
      <path
        d="M106.318 10.4844L109.982 12.8394"
        stroke={color}
        strokeWidth="1.57004"
        strokeLinecap="round"
      />
      <path
        d="M112.965 1L116.549 9.24031"
        stroke={color}
        strokeWidth="1.57004"
        strokeLinecap="round"
      />
      <path
        d="M125.65 20.0397C125.65 17.2925 126.289 12.7067 129.612 16.8598C131.657 19.845 132.424 25.7893 130.89 28.8003"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M118.878 22.5723C118.452 21.0581 118.239 18.2374 120.795 19.068L123.606 24.7787"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M123.607 24.7745L120.795 19.0638C120.582 17.3766 121.69 14.651 124.374 16.8574L125.652 20.0372L126.93 23.217"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M126.992 32.8555C126.294 34.3821 125.553 37.8534 128.169 39.5281"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M130.262 30.6322C130.872 28.8879 132.721 25.425 135.233 25.5297C137.746 25.6343 135.757 28.9313 135.233 30.1088L131.57 37.3048C130.785 39.2674 129.608 42.8 132.355 46.8559C135.103 50.5193 144.577 59.9395 154.783 61.5095"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M152.897 116.201C153.682 118.992 156.56 125.464 161.794 129.023M144.785 111.621L155.121 114.631L144.785 111.621ZM154.598 119.864C155.732 116.157 157.188 106.964 153.944 99.8462C149.888 90.9494 147.402 79.5666 149.364 71.9781C150.934 65.9073 156.648 65.0001 159.308 65.3054C163.495 65.7859 170.717 70.8006 170.298 84.4075C169.775 101.416 165.85 115.939 160.224 127.191L154.598 119.864Z"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M150.41 126.011C150.41 119.339 150.366 114.629 149.625 112.797C159.673 116.565 171.867 115.588 176.708 114.629C176.839 114.934 177.912 117.847 181.157 127.058C185.212 138.572 182.334 177.037 181.157 181.355C179.979 185.673 176.839 185.804 172.26 185.28C168.596 184.862 163.755 174.813 161.793 169.842C152.634 152.702 150.41 133.841 150.41 126.011Z"
        fill={color}
      />
      <path
        d="M186.543 90.9746C186.406 90.6401 186.024 90.4794 185.69 90.6158C185.355 90.7522 185.195 91.134 185.331 91.4685L186.543 90.9746ZM191.531 109.408L191.91 109.941L192.255 109.697L192.173 109.281L191.531 109.408ZM164.671 115.548L164.544 116.19L164.567 116.194L164.59 116.197L164.671 115.548ZM144.784 111.623L144.134 111.7L144.191 112.173L144.657 112.265L144.784 111.623ZM149.14 73.297L149.758 73.5129L149.794 73.4081V73.297H149.14ZM153.866 67.0572C154.182 66.8826 154.297 66.4847 154.123 66.1684C153.948 65.852 153.55 65.7371 153.234 65.9116L153.866 67.0572ZM185.331 91.4685C186.622 94.6343 189.54 102.685 190.889 109.534L192.173 109.281C190.801 102.315 187.848 94.1764 186.543 90.9746L185.331 91.4685ZM191.153 108.874C187.499 111.465 177.111 116.444 164.752 114.899L164.59 116.197C177.351 117.792 188.061 112.671 191.91 109.941L191.153 108.874ZM164.798 114.906L144.911 110.981L144.657 112.265L164.544 116.19L164.798 114.906ZM145.433 111.545C144.657 105.029 144.566 88.3617 149.758 73.5129L148.523 73.0811C143.248 88.1677 143.341 105.046 144.134 111.7L145.433 111.545ZM149.794 73.297C149.794 72.7709 150.087 71.5968 150.781 70.3252C151.466 69.0705 152.491 67.816 153.866 67.0572L153.234 65.9116C151.574 66.8275 150.394 68.3034 149.633 69.6984C148.88 71.0765 148.486 72.4714 148.486 73.297H149.794Z"
        fill={color}
      />
      <path
        d="M184.167 102.636C184.191 102.996 184.503 103.269 184.863 103.245C185.224 103.221 185.497 102.909 185.473 102.549L184.167 102.636ZM185.937 91.2185L185.285 91.2741L185.285 91.2741L185.937 91.2185ZM185.12 81.9291L184.469 81.9878V81.9878L185.12 81.9291ZM178.709 60.7337L179.259 60.379L179.259 60.379L178.709 60.7337ZM169.345 56.9689C169.005 57.0913 168.829 57.4661 168.951 57.806C169.073 58.1459 169.448 58.3223 169.788 58.1999L169.345 56.9689ZM185.473 102.549C185.473 102.552 185.472 102.544 185.473 102.521C185.474 102.5 185.476 102.47 185.479 102.433C185.486 102.356 185.498 102.258 185.515 102.135C185.55 101.89 185.603 101.574 185.668 101.194C185.799 100.439 185.978 99.4484 186.146 98.3471C186.48 96.1538 186.784 93.4557 186.589 91.1629L185.285 91.2741C185.467 93.4031 185.184 95.9718 184.852 98.1498C184.687 99.2342 184.512 100.206 184.379 100.971C184.313 101.351 184.257 101.685 184.22 101.952C184.185 102.197 184.155 102.452 184.167 102.636L185.473 102.549ZM186.589 91.1629C186.378 88.696 186.109 85.6188 185.772 81.8705L184.469 81.9878C184.806 85.7343 185.075 88.8095 185.285 91.2741L186.589 91.1629ZM185.772 81.8705C184.82 71.2959 181.059 63.1702 179.259 60.379L178.16 61.0883C179.848 63.7054 183.536 71.6286 184.469 81.9878L185.772 81.8705ZM179.259 60.379C178.296 58.8866 176.701 57.7244 174.932 57.0879C173.16 56.4508 171.151 56.3187 169.345 56.9689L169.788 58.1999C171.253 57.6726 172.943 57.7632 174.489 58.3191C176.036 58.8757 177.378 59.8768 178.16 61.0883L179.259 60.379Z"
        fill={color}
      />
      <path
        d="M182.309 172.71C183.437 148.17 178.435 124.984 175.662 115.939C182.655 114.995 188.164 111.972 190.185 110.967C192.215 118.623 195.187 138.277 196.408 147.279C199.454 157.137 198.805 171.312 198.1 177.167C198.551 180.732 195.657 182.148 194.152 182.41C186.144 185.032 182.92 177.036 182.309 172.71Z"
        fill={color}
      />
      <path
        d="M118.617 22.125C120.841 25.7012 124.138 34.3712 121.626 46.7221C121.844 49.3826 125.727 58.1797 128.692 62.1608C133.271 68.3101 142.822 75.2445 148.71 77.207"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M159.211 59.4723C157.48 58.407 144.46 59.4338 141.928 43.0555C137.594 43.1062 135.238 39.5561 138.545 38.0369C142.07 36.219 141.805 32.8816 141.166 30.9152C140.151 28.3364 140.09 25.6288 140.308 25.0625"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M145.524 37.1693C144.905 37.1766 144.394 36.4296 144.383 35.5008C144.372 34.5721 144.865 33.8134 145.484 33.8061C146.104 33.7988 146.614 34.5459 146.625 35.4746C146.636 36.4033 146.143 37.1621 145.524 37.1693Z"
        fill={color}
      />
      <path
        d="M148.166 31.7323C147.443 30.9596 145.573 29.8289 143.879 31.4897"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M153.079 46.7891C151.75 48.834 150.291 49.4147 147.457 48.0951"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M163.957 32.4512C164.265 33.1273 164.523 34.6623 163.092 35.3929"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M179.212 25.5061C180.898 34.7314 175.622 41.676 171.797 47.0146C167.712 44.8077 161.017 39.5596 163.585 38.993C166.284 38.3977 169.13 31.0361 166.509 28.7841C163.434 26.1419 160.662 30.1396 160.134 33.1708L157.657 28.8878C158.358 25.892 158.632 20.6369 154.128 23.5829C149.624 26.5288 143.017 25.7572 140.277 25.0031C134.873 21.1354 126.478 12.1139 136.125 6.96915C144.15 2.69017 154.591 8.09997 160.965 12.961C165.28 11.8217 176.913 12.9277 179.212 25.5061Z"
        fill={color}
      />
      <path
        d="M171.497 46.4004C169.546 48.7486 168.577 50.6986 168.698 54.7381"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M183.61 200.917C167.386 201.571 159.666 198.316 159.666 196.076C159.666 195.16 159.143 194.244 162.807 192.935C161.237 195.073 161.812 199.137 176.675 198.3C179.074 198.431 184.473 197.803 186.88 194.244H188.058C199.833 191.235 206.768 193.705 206.768 195.945C206.768 198.185 197.086 200.373 183.61 200.917Z"
        fill={color}
      />
      <path
        d="M186.648 194.186C195.412 195.023 196.517 187.993 195.974 184.373"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
      <path
        d="M175.042 187.77C175.042 188.337 174.911 189.575 174.388 189.994C173.733 190.517 161.958 189.209 162.22 195.096C162.089 195.925 163.397 197.19 166.537 197.582C170.954 198.134 183.614 199.746 186.65 194.181C186.826 193.857 186.971 193.508 187.079 193.134L188.256 188.162"
        stroke={color}
        strokeWidth="1.30836"
        strokeLinecap="round"
      />
    </svg>
  );
}
